import emblem from '../../assets/brand/midgard_m_emblem.png';

/**
 * Midgard brand mark — the approved glowing circular rune-"M" emblem.
 *
 * Renders the approved emblem asset (src/assets/brand/midgard_emblem.png).
 * To swap in a future variant, replace that single asset file — no caller
 * (header, auth, nav, oDIN) needs to change. `glow` toggles the living pulse.
 */
export const BrandMark = ({ size = 40, className = '', testId = 'brand-mark', glow = true }) => {
  return (
    <span
      className={`mg-brandmark ${glow ? 'mg-brandmark-glow' : ''} ${className}`}
      style={{ width: size, height: size }}
      role="img"
      aria-label="Midgard"
      data-testid={testId}
    >
      <img src={emblem} alt="Midgard" className="mg-brandmark-img" draggable="false" />
    </span>
  );
};

export default BrandMark;
